import OnboardingType from "../../../../../shared/onboarding/onboarding-type";
import { sortByName } from "../../../../../shared/utility";
import {
  FETCH_SET_DRESSING_OVERVIEW,
  ALIAS_SET_DRESSING,
  UNALIAS_SET_DRESSING,
  SAVE_ALIAS_SET_DRESSING,
  SAVE_REMOVE_ALIAS_SET_DRESSING
} from "./actions";
import { DELETE_MULTIPLE_SET_DRESSINGS } from "./actions";

interface SetDressingOverviewState {
  overview: any;
  loading: boolean;
  readOnly: boolean;
  onboardingSteps: OnboardingType[];
  processingSetDressingIds: string[];
}

export const OnboardingStep1ClassName = 'set-dressings-overview-onboarding-step-1';
export const OnboardingStep2ClassName = 'set-dressings-overview-onboarding-step-2';
export const OnboardingStep3ClassName = 'set-dressings-overview-onboarding-step-3';
export const OnboardingStep4ClassName = 'set-dressings-overview-onboarding-step-4';

const defaultState: SetDressingOverviewState = {
  overview: {},
  loading: true,
  readOnly: false,
  processingSetDressingIds: [],
  onboardingSteps: [
    {
      target: '.' + OnboardingStep1ClassName,
      title: 'Set Dressings Acquired',
      content: `This shows the percentage of set dressings acquired.`
    },
    {
      target: '.' + OnboardingStep2ClassName,
      title: 'Merge Set Dressings',
      content: `<p>Drag and drop set dressings on top of each other to merge them.</p>
           <p>This is useful for combining duplicate set dressings or aliasing set dressings that are the same but have different names.</p>`
    }
  ]
};

const reducer = (state = defaultState, action: any = {}) => {
  switch (action.type) {
    case FETCH_SET_DRESSING_OVERVIEW + "_PENDING": {
      return {
        ...state,
        loading: true,
        overview: null,
        errors: null
      };
    }

    case FETCH_SET_DRESSING_OVERVIEW + "_FULFILLED": {
      return {
        ...state,
        loading: false,
        overview: action.payload.data,
        readOnly: action.payload.data.readOnly,
        errors: null
      };
    }

    case SAVE_ALIAS_SET_DRESSING + "_PENDING": {
      const aliasSetDressing = action.meta.aliasSetDressing;
      const mainSetDressing = action.meta.mainSetDressing;
      return {
        ...state,
        processingSetDressingIds: [
          ...state.processingSetDressingIds,
          aliasSetDressing.id,
          mainSetDressing.id
        ]
      };
    }

    case SAVE_ALIAS_SET_DRESSING + "_FULFILLED":
    case SAVE_ALIAS_SET_DRESSING + "_REJECTED": {
      const aliasSetDressing = action.meta.aliasSetDressing;
      const mainSetDressing = action.meta.mainSetDressing;
      return {
        ...state,
        processingSetDressingIds: state.processingSetDressingIds.filter(
          id => id !== aliasSetDressing.id && id !== mainSetDressing.id
        )
      };
    }

    case SAVE_REMOVE_ALIAS_SET_DRESSING + "_PENDING": {
      const aliasSetDressing = action.meta.aliasSetDressing;
      const mainSetDressing = action.meta.mainSetDressing;
      return {
        ...state,
        processingSetDressingIds: [
          ...state.processingSetDressingIds,
          aliasSetDressing.id,
          mainSetDressing.id
        ]
      };
    }

    case SAVE_REMOVE_ALIAS_SET_DRESSING + "_FULFILLED":
    case SAVE_REMOVE_ALIAS_SET_DRESSING + "_REJECTED": {
      const aliasSetDressing = action.meta.aliasSetDressing;
      const mainSetDressing = action.meta.mainSetDressing;
      return {
        ...state,
        processingSetDressingIds: state.processingSetDressingIds.filter(
          id => id !== aliasSetDressing.id && id !== mainSetDressing.id
        )
      };
    }

    case ALIAS_SET_DRESSING: {
      const aliasSetDressing = action.meta.aliasSetDressing;
      const mainSetDressing = action.meta.mainSetDressing;
      let setDressings = [...state.overview.setDressings];
      const setDressing = setDressings.find((c) => c.id === mainSetDressing.id);
      const aliasSetDressingIndex = setDressings.findIndex(
        (c) => c.id === aliasSetDressing.id
      );

      if (setDressing.aliases) {
        setDressing.aliases = [
          ...setDressing.aliases,
          aliasSetDressing
        ];
      } else {
        setDressing.aliases = [aliasSetDressing];
      }

      setDressings[aliasSetDressingIndex].aliases = [];

      setDressings.splice(aliasSetDressingIndex, 1);

      let overview = { ...state.overview, setDressings };
      return {
        ...state,
        overview: overview
      };
    }

    case UNALIAS_SET_DRESSING: {
      const aliasSetDressing = action.meta.aliasSetDressing;
      const mainSetDressing = action.meta.mainSetDressing;
      let setDressings = [...state.overview.setDressings];
      const setDressing = setDressings.find((c) => c.id === mainSetDressing.id);

      const aliasSetDressingIndex = setDressing.aliases.findIndex(
        (a) => a.id === aliasSetDressing.id
      );
      setDressing.aliases.splice(aliasSetDressingIndex, 1);

      setDressings.push(aliasSetDressing);

      sortByName(setDressings);

      let overview = { ...state.overview, setDressings };
      return {
        ...state,
        overview: overview
      };
    }

    case DELETE_MULTIPLE_SET_DRESSINGS + "_PENDING": {
      return {
        ...state,
        loading: true,
        errors: null
      };
    }

    case DELETE_MULTIPLE_SET_DRESSINGS + "_FULFILLED": {
      const deletedSetDressingIds = action.meta.setDressingIds;
      let setDressings = state.overview.setDressings.filter(
        (setDressing) => !deletedSetDressingIds.includes(setDressing.id)
      );

      let overview = { ...state.overview, setDressings };
      return {
        ...state,
        overview: overview,
        loading: false
      };

    }

    case DELETE_MULTIPLE_SET_DRESSINGS + "_REJECTED": {
      return {
        ...state,
        errors: action.payload.response.data.errors,
        loading: false
      };
    }

    default:
      return state;
  }
};

export default reducer;
